import React, { useState, useEffect, useRef } from 'react';
import ResponsiveModal from "@components/ResponsiveModal";
import './ImagePreviewModal.css';

const ImagePreviewModal = ({ visible, src, onClose }) => {
    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const dragStartRef = useRef({ x: 0, y: 0 });
    const positionStartRef = useRef({ x: 0, y: 0 });
    
    const MIN_SCALE = 0.1;
    const MAX_SCALE = 5;

    // 当 modal 关闭时重置缩放和位置
    useEffect(() => {
        if (!visible) {
            setScale(1);
            setPosition({ x: 0, y: 0 });
        }
    }, [visible]);

    const handleDownload = () => {
        if (src) {
            const link = document.createElement('a');
            link.href = src;
            link.download = `image_${Date.now()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handleOpenInNewTab = () => {
        if (src) {
            window.open(src, '_blank');
        }
    };

    const handleWheel = (e) => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? -0.1 : 0.1;
        setScale(prevScale => {
            const newScale = prevScale + delta;
            // 当缩放回到 1 时，重置位置
            if (newScale <= 1) {
                setPosition({ x: 0, y: 0 });
            }
            return Math.min(Math.max(newScale, MIN_SCALE), MAX_SCALE);
        });
    };

    const handleMouseDown = (e) => {
        if (scale <= 1) return;
        e.preventDefault();
        setIsDragging(true);
        dragStartRef.current = { x: e.clientX, y: e.clientY };
        positionStartRef.current = { x: position.x, y: position.y };
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        const deltaX = e.clientX - dragStartRef.current.x;
        const deltaY = e.clientY - dragStartRef.current.y;
        setPosition({
            x: positionStartRef.current.x + deltaX,
            y: positionStartRef.current.y + deltaY
        });
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    // 双击重置
    const handleDoubleClick = () => {
        setScale(1);
        setPosition({ x: 0, y: 0 });
    };

    return (
        <ResponsiveModal
            open={visible}
            onCancel={onClose}
            footer={null}
            width="90vw"
            style={{ top: 20 }}
            className="image-preview-modal"
            centered
            destroyOnClose
        >
            <div className="image-preview-container">
                <div 
                    className="image-preview-content"
                    onWheel={handleWheel}
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseLeave}
                >
                    {src && (
                        <img
                            src={src}
                            alt="预览图片"
                            className="preview-image"
                            style={{ 
                                transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
                                cursor: isDragging ? 'grabbing' : (scale > 1 ? 'grab' : 'zoom-in')
                            }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseDown={handleMouseDown}
                            onDoubleClick={handleDoubleClick}
                            draggable={false}
                        />
                    )}
                </div>
                {scale !== 1 && (
                    <div className="zoom-indicator">
                        {Math.round(scale * 100)}%
                    </div>
                )}
            </div>
        </ResponsiveModal>
    );
};

export default ImagePreviewModal; 
